export const CLIMATEPARTNER_INTERNAL_ACCOUNT = "climatepartner-internal";
